export default `# Avatars

The avatars panel shows all AI personas participating in your session. Monitor their activity, request responses, and manage physical device assignments.

---

## Stats Overview

Four cards at the top summarise the session:
- **Active** — Number of avatars in the session
- **Contributions** — Total ideas submitted across all avatars
- **Devices** — Physical devices currently assigned
- **Least Active** — The avatar that needs the most engagement (warning indicator)

---

## Avatar Cards

Each avatar card displays:
- **Name and role** — The avatar's persona identity
- **Status indicator**:
  - 🟢 **Speaking** — Currently generating or delivering a response
  - 🟡 **Thinking** — Processing a contribution
  - ⚪ **Listening** — Idle, waiting for input
- **Contributions count** — How many ideas this avatar has submitted
- **Acceptance rate** — How often their suggestions were accepted
- **Request Response** button — Manually prompt this specific avatar

---

## Physical Device Assignment

If physical avatar devices (e.g. Pi + LCD displays) are available, each card has a device dropdown:
- Select a device to pair with the avatar
- View **battery level** (colour-coded: green >75%, amber 25–75%, red <25%)
- See **charging status** if plugged in

For full device management, use the [Devices](help:session-devices) panel.

---

## Response Modes

At the bottom of the panel, choose how all avatars behave:

| Mode | Effect |
|------|--------|
| Open Ideas | Freely generate creative suggestions |
| Structured | Follow formal discussion patterns |
| Solution | Focus on actionable, practical solutions |
| Critique | Challenge and stress-test ideas |
| Silent | Listen without contributing automatically |

The active mode is highlighted. A description below explains the current mode's behaviour.

---

## Tips

- **Check the Least Active avatar** — It may have a perspective that's been missed in the discussion
- **Use Request Response** on quiet avatars rather than asking all — this gives targeted input
- **Match response mode to session phase** — Use Open Ideas early, switch to Critique before finalising decisions`;
